<template>
    <modal-ui
        :id="id"
        size="modal-md"
        title="API-ключ создан">
        <div class="row mb-3">
            <div class="col-12">
                <div class="alert alert-warning">
                    {{ state.warning }}
                </div>
            </div>
            <div class="col-12">
                <label class="form-label">Секретный ключ</label>
                <div class="input-group">
                    <input
                        class="form-control font-monospace"
                        type="text"
                        readonly
                        :value="state.apiKey">
                    <button
                        class="btn btn-outline-primary"
                        type="button"
                        @click="copyKey">
                        {{ copied ? 'Скопировано' : 'Копировать' }}
                    </button>
                </div>
            </div>
            <div class="col-12 mt-3">
                <small class="text-muted">
                    Используйте заголовок <code>X-API-Key</code> для
                    <code>/api/v1/external/students</code> и
                    <code>/api/v1/external/entrances</code>.
                </small>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <button-ui button-class="btn-primary" @click="close">
                    Готово
                </button-ui>
            </div>
        </div>
    </modal-ui>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from 'vue';
import { useModal } from '@/composables/useModal';
import useNotifications from '@/composables/useNotifications';

export default defineComponent({
    name: 'ApiClientKeyRevealModal',
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const modal = useModal(props.id);
        const copied = ref(false);

        const state = reactive({
            apiKey: '',
            warning: 'Сохраните ключ сейчас — повторно получить секрет нельзя',
        });

        onMounted(() => {
            state.apiKey = modal.data?.apiKey || '';
            if (modal.data?.warning) {
                state.warning = modal.data.warning;
            }
        });

        function copyKey() {
            if (!state.apiKey) return;
            navigator.clipboard.writeText(state.apiKey).then(() => {
                copied.value = true;
                useNotifications.success('Скопировано', 'API-ключ скопирован в буфер');
                setTimeout(() => {
                    copied.value = false;
                }, 2000);
            }).catch(() => {
                useNotifications.error('Ошибка', 'Не удалось скопировать ключ');
            });
        }

        function close() {
            modal.ok({});
        }

        return {
            state,
            copied,
            copyKey,
            close,
        };
    },
});
</script>
